<template>
  <div class="login">
    <img src="../assets/img/aaa.jpg" alt="">
    <div class="txt_c p_a w_100Per" style="top:400px">
      <div class='btn' @click="go">开启我的收入账单</div>
      <div>* 以下数据来源1月至11月</div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        query: {}
      }
    },
    methods: {
      go() {
        this.$router.push({
          path: "/account",
          query: this.$route.query
        })
      }
    }
  }

</script>

<style lang="less" scoped>
  .btn {
    display: inline-block;
    margin-bottom: 20px;
    background-image: linear-gradient(#fff6d6, #fcd06f);
    font-size: 40px;
    padding: 18px 80px;
    color: #397a5d;
    border-radius: 60px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/index.vue